import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  DEFAULT_TEMPLATE_BUILD_SLUG,
  BLANK_TEMPLATE_BUILD_SLUG,
} from '../../modules/templates/constants/common';
import useTemplateBySlug from '../../modules/templates/hooks/use-template-by-slug';

const defaultCreateSiteByTemplate = () => {};

function UseTemplate({ templateSlug, locale, createSiteByTemplate = defaultCreateSiteByTemplate }) {
  const { template: selectedTemplate, attemptedSingleFetch } = useTemplateBySlug(
    templateSlug,
    locale
  );

  const lastInvokedSlugRef = useRef(null);

  useEffect(() => {
    let targetSlug = null;

    if (templateSlug === BLANK_TEMPLATE_BUILD_SLUG) {
      targetSlug = BLANK_TEMPLATE_BUILD_SLUG;
    } else if (attemptedSingleFetch && !selectedTemplate) {
      targetSlug = DEFAULT_TEMPLATE_BUILD_SLUG;
    } else if (selectedTemplate) {
      targetSlug = selectedTemplate.slug;
    }

    if (targetSlug && lastInvokedSlugRef.current !== targetSlug) {
      createSiteByTemplate(targetSlug, locale);
      lastInvokedSlugRef.current = targetSlug;
    }
  }, [templateSlug, locale, attemptedSingleFetch, selectedTemplate, createSiteByTemplate]);

  return null;
}

UseTemplate.propTypes = {
  templateSlug: PropTypes.string.isRequired,
  createSiteByTemplate: PropTypes.func,
  locale: PropTypes.string.isRequired,
};

export default UseTemplate;
